import { Dialog, DialogContent } from '@material-ui/core';
import React from 'react'
import { useMedia } from 'react-use';
import styled from 'styled-components';
import { TextWrapper } from '../../layout/reusables';
import { ViewModalHeaderSection } from './photo-viewer-modal';


export default function VideoPlayerModal({ open, setOpen, video, name, logo }) {
    
    const isMobile = useMedia("(max-width: 600px)")

    const handleCloseModal = () => {
        setOpen(false)
    }
    
    return (
        <Dialog
            open={open}
            onClose={handleCloseModal}
            fullWidth={true}
            maxWidth="md"
            fullScreen={isMobile ? true : false}
        >
            <DialogContent style={{padding: '0 0 20px 0'}}>
                <Container>
                    <ViewModalHeaderSection name={name} image={logo} handleClose={handleCloseModal}/>
                    <Video autoPlay controls preload="metadata">
                        <source src={`${video.url}#t=0.5`} />
                    </Video>
                    <TextWrapper style={{textAlign: 'center', padding: 20}}>
                        <Title>{video.title}</Title>
                        <Description>{video.description}</Description>
                    </TextWrapper>
                </Container>
            </DialogContent>
        </Dialog>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
const Title = styled.h1`
    font-size: 32px;
    line-height: 1.3;
    margin-bottom: 10px;
    font-weight: 500;
    text-align: left;
    color: black;
    text-align: center;
    font-family: 'Quattrocento';
    font-weight: 400;

    @media (max-width: 550px) {
        font-size: 22px;
    }
`
const Description = styled.p`
    opacity: 0.8;
    line-height: 1.3;
`;
const Video = styled.video`
    width: 100%;
    max-height: 60vh;
    margin-bottom: 20px;
`;